import employment from "./employment";
import expo from "./expo";
import humanResource from "./human-resource";
import interviews from "./interviews";
import lectures from "./lectures";
import meetings from "./meetings";
import recruitments from "./recruitments";
import textings from "./textings";

export default {
    employment,
    expo,
    humanResource,
    interviews,
    lectures,
    meetings,
    recruitments,
    textings,
};
